import React, { useEffect, useState } from 'react';

function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    document.title = 'OPR - Óptica Paris';
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calcular las posiciones de las cintas basadas en el scroll
  const ribbonBottomTransform = `rotate(3deg) translateX(${scrollY * 0.5}px)`;
  const ribbonTopTransform = `rotate(-4deg) translateX(${-scrollY * 0.5}px)`;

  return (
    <div className="home-container">
      {/* Primera sección - Carrusel */}
      <section>
        <div id="carouselExampleIndicators" className="carousel slide d-none d-md-block" data-bs-ride="carousel" data-bs-interval="3000">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={process.env.PUBLIC_URL + '/banner/desktop/banner1.webp'} className="d-block w-100" alt="Banner 1" style={{borderRadius: '20px 20px'}} />
              {/*<div
                className="carousel-caption d-flex flex-column justify-content-center"
                style={{
                  width: '48%',
                  top: 0,
                  left: 0,
                  textAlign: 'left',
                  padding: '3% 5% 3% 4%',
                  height: '100%',
                  background: 'linear-gradient(90deg, rgba(60,20,20,0.95) 80%, rgba(60,20,20,0.0) 100%)',
                  borderTopLeftRadius: '20px',
                  borderBottomLeftRadius: '20px',
                  color: '#fff',
                  fontFamily: 'Merriweather, serif'
                }}
              >
                <h2 className='title-banner' style={{color:'white'}}>
                  Hola al<br /> <span>nuevo capítulo<br/>de Óptica París</span>
                </h2>
                <hr className='line-banner' style={{
                  borderTop: '2px solid #fff',
                  opacity: 1,
                  width: '100%'
                }} />
                <p className='txt-banner' style={{color:'white'}}>
                  <strong>60 AÑOS </strong> 
                    acompañando a Veracruz, con innovación constante para mejorar tu experiencia visual. Evolucionamos para brindarte lo mejor, hoy y siempre.
                  
                </p>
              </div>*/}
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/desktop/banner2.webp'} style={{borderRadius: '20px 20px'}} className="d-block w-100" alt="Banner 2" />
              {/*Texto para banner
              <div className="carousel-caption d-flex flex-column justify-content-center" style={{width: '50%', top: '0', left: '0%', textAlign:'left', padding:'0% 5%', height:'100%'}}>
                <h2 className='title-banner' style={{color:'var(--second-color)'}}>Compromiso<br></br><span style={{color: 'var(--first-color)'}}>con el Futuro</span> </h2>
                <hr className='line-banner' style={{borderTop: '2px solid var(--first-color)', opacity: '1'}}></hr>
                <p className='txt-banner'  style={{color:'var(--second-color)'}}>Valoramos profundamente tu confianza y nos esforzamos constantemente por mejorar e innovar. Utilizamos la tecnología para ofrecer una experiencia visual de alta calidad, precisa y a la vanguardia.</p>
              </div>*/}
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/desktop/banner3.webp'} className="d-block w-100" alt="Banner 3" />
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/desktop/banner4.png'} style={{borderRadius: '20px 20px'}} className="d-block w-100" alt="Banner 4" />
              {/*Texto para banner*/}
              {/*<div className="carousel-caption d-flex flex-column justify-content-center" style={{width: '40%', top: '0', left: '0%', textAlign:'left', padding:'0% 5%', height:'100%', borderTopLeftRadius: '20px 20px', borderBottomLeftRadius:'20px 20px', background: 'linear-gradient(90deg, rgba(60, 20, 20, 0.84) 87%, rgb(60 20 20 / 0%) 100%)'}}>
                <h2 className='title-banner' style={{color:'white'}}>Outlet de <br></br><span>Lentes</span></h2>
                <hr className='line-banner' style={{borderTop: '2px solid white', opacity: '1'}}></hr>
                <p className='txt-banner' style={{fontWeight:'400'}}>Contamos con más de 100 modelos en nuestro Outlet en <img className='logo-ml' src={process.env.PUBLIC_URL + '/logo-ML.png'} style={{background:'white', padding:'1% 1%', borderRadius: '30px 30px'}} alt="Mercado Libre"/>. No pierdas nuestras promociones y compra ahora.</p>
              </div>*/}
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/desktop/banner5.1.png'} style={{borderRadius: '20px 20px'}} className="d-block w-100" alt="Banner 5" />
              {/*Texto para Banner*/}
              <div className="carousel-caption d-flex flex-column justify-content-center" style={{width: '50%', color: 'var(--third-color)', bottom: '20%', left: '0%', textAlign:'left', padding:'0% 5%', height:'fit-content'}}>
                <h2 className='title-banner' style={{color:'var(--second-color)'}}>Hay<br></br><span style={{color: 'var(--first-color)'}}>que tener 2</span> </h2>
                <hr className='line-banner' style={{borderTop: '2px solid var(--first-color)', opacity: '1'}}></hr>
                <p className='txt-banner'  style={{color:'var(--second-color)'}}>Por si se rompen, por si se pierden o te quieres ver diferente. Siempre es bueno tener 2 pares de lentes.</p>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
        <div id="carouselExampleIndicatorsMobile" className="carousel slide d-block d-sm-block d-md-none" data-bs-touch="true" data-bs-ride="carousel" data-bs-interval="3000">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={process.env.PUBLIC_URL + '/banner/movil/banner2.png'} className="d-block w-100" alt="Banner 1" style={{borderRadius: '20px 20px'}}/>
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/movil/banner3.png'} style={{borderRadius: '20px 20px'}} className="d-block w-100" alt="Banner 2"/>
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/movil/banner6.png'} className="d-block w-100" alt="Banner 3"/>
              {/*<div className="carousel-caption d-flex flex-column justify-content-center" style={{width: '50%', top: '0', left: '0%', textAlign:'left', padding:'0% 5%', height:'100%', borderTopLeftRadius: '20px 20px', borderBottomLeftRadius:'20px 20px', background: 'linear-gradient(90deg, rgba(60, 20, 20, 0.84) 87%, rgb(60 20 20 / 0%) 100%)'}}>
                <h2 className='title-banner' style={{color:'white'}}>Outlet de <br></br><span>Lentes</span></h2>
                <hr className='line-banner' style={{borderTop: '2px solid white', opacity: '1'}}></hr>
                <p className='txt-banner' style={{fontWeight:'400'}}>Contamos con más de 100 modelos en nuestro Outlet en <img className='logo-ml' src={process.env.PUBLIC_URL + '/logo-ML.png'} style={{background:'white', width:'auto',padding:'1% 1%', borderRadius: '30px 30px'}} alt="Mercado Libre"/>. No pierdas nuestras promociones y compra ahora.</p>
              </div>*/}
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/movil/banner7.webp'} style={{borderRadius: '20px 20px'}} className="d-block w-100" alt="Banner 4"/>
            </div>
            <div className="carousel-item">
              <img src={process.env.PUBLIC_URL + '/banner/movil/banner8.png'} style={{borderRadius: '20px 20px'}} className="d-block w-100" alt="Banner 5"/>
            </div>
          </div>

          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicatorsMobile" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicatorsMobile" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      {/* Segunda sección - Imagen y contenido */}
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-5 ps-0 text-start">
              <img src={process.env.PUBLIC_URL + '/fotoveracruz.png'} className="img-fluid" alt="Foto Veracruz" />
            </div>
            <div className="col-12 col-md-7 indcont-right text-start" >
              <h1 className="title2 graytitle2 text-start">
                Nuestra Identidad Local
              </h1>
              <h2 className="title2 redtitle2 text-start">
                Veracruz como Nuestra Esencia
              </h2>
              <p className="txt2">
                Veracruz, con su mar, su sol, su puerto y sus vistas inigualables, no solo es el contexto donde nacimos, sino el alma que inspira nuestra visión. Al igual que nuestras costas ofrecen una visión clara del horizonte <strong style={{ color: 'var(--first-color)' }}>ÓPTICA PARÍS</strong> se compromete a ofrecerte claridad visual en todos los aspectos de tu vida.
              </p>
              <p className="txt2" style={{ marginTop: '1rem' }}>
                El paisaje local, con su fortaleza y belleza, se convierte en la metáfora perfecta de nuestra misión: ayudar a ver el mundo más claro que nunca.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tercera sección (estructura visual tipo maqueta) - SOLO DESKTOP */}
      <section className="anos-section d-none d-md-block">
        <div className="container-fluid">
          <div className="row">
            {/* Columna izquierda */}
            <div className="col-2 p-0">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 img-year p-0">
                    <div id="carouselExample1" className="carousel slide anos-carousel" data-bs-ride="carousel">
                      <div className="carousel-inner rounded-4">
                        <div className="carousel-item active" data-bs-interval="10000">
                          <img src={process.env.PUBLIC_URL + '/60anos1.png'} className="d-block w-100" alt="Variedad de lentes" />
                        </div>
                        <div className="carousel-item" data-bs-interval="10000">
                          <img src={process.env.PUBLIC_URL + '/1.png'} className="d-block w-100" alt="En tendencia" />
                        </div>
                      </div>
                      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample1" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#carouselExample1" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 red-square">
                    <p>
                      Inmensa
                    </p>
                    <p>
                      <strong>variedad</strong>
                    </p>
                    <p>
                      <strong>de marcas</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Columna central */}
            <div className="col-8">
              <div className="container">
                <div className="row title-section text-center">
                  <h1 className="anos-title">60 AÑOS</h1>
                  <h2 className="anos-subtitle">acompañando a Veracruz</h2>
                </div>
                <div className="row">
                  <div className="col-4 img-year">
                    <div id="carouselExample2" className="carousel slide anos-carousel" data-bs-ride="carousel">
                      <div className="carousel-inner rounded-4">
                        <div className="carousel-item active" data-bs-interval="10000">
                          <img src={process.env.PUBLIC_URL + '/60anos2.png'} className="d-block w-100" alt="Diferentes Marcas" />
                        </div>
                        <div className="carousel-item" data-bs-interval="10000">
                          <img src={process.env.PUBLIC_URL + '/2.png'} className="d-block w-100" alt="Lente Dior" />
                        </div>
                      </div>
                      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample2" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#carouselExample2" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="container-fluid">
                    
                      <div className="row">
                        <div className="col-6 img-year ps-0">
                          <img src={process.env.PUBLIC_URL + '/logo60.png'} className="anos-logo my-3" alt="60 años viéndote, Ver" />
                          <div id="carouselExample3" className="carousel slide anos-carousel" data-bs-ride="carousel">
                            <div className="carousel-inner rounded-4">
                              <div className="carousel-item active" data-bs-interval="10000">
                                <img src={process.env.PUBLIC_URL + '/60anos3.png'} className="d-block w-100" alt="OPV equipado" />
                              </div>
                              <div className="carousel-item" data-bs-interval="10000">
                                <img src={process.env.PUBLIC_URL + '/3.png'} className="d-block w-100" alt="OPV examen de la vista" />
                              </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample3" data-bs-slide="prev">
                              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExample3" data-bs-slide="next">
                              <span className="carousel-control-next-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Next</span>
                            </button>
                          </div>
                        </div>
                        <div className="col-6 img-year pe-0">
                          <div id="carouselExample4" className="carousel slide anos-carousel" data-bs-ride="carousel">
                            <div className="carousel-inner rounded-4">
                              <div className="carousel-item active" data-bs-interval="10000">
                                <img src={process.env.PUBLIC_URL + '/60anos4.png'} className="d-block w-100" alt="Instalaciones" />
                              </div>
                              <div className="carousel-item" data-bs-interval="10000">
                                <img src={process.env.PUBLIC_URL + '/4.png'} className="d-block w-100" alt="Examen de la vista computarizado " />
                              </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample4" data-bs-slide="prev">
                              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExample4" data-bs-slide="next">
                              <span className="carousel-control-next-icon" aria-hidden="true"></span>
                              <span className="visually-hidden">Next</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-12 red-square">
                          <p>
                            <strong>Licenciados en Optometría</strong> 
                          </p>
                          <p>
                            en constante actualización
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Columna derecha */}
            <div className="col-2 p-0">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 img-year p-0">
                    <div id="carouselExample5" className="carousel slide anos-carousel" data-bs-ride="carousel">
                      <div className="carousel-inner rounded-4">
                        <div className="carousel-item active" data-bs-interval="10000">
                          <img src={process.env.PUBLIC_URL + '/60anos5.png'} className="d-block w-100" alt="Examen de cornea con tecnología" />
                        </div>
                        <div className="carousel-item" data-bs-interval="10000">
                          <img src={process.env.PUBLIC_URL + '/5.png'} className="d-block w-100" alt="Examen Topógrafo corneal" />
                        </div>
                      </div>
                      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample5" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target="#carouselExample5" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 red-square">
                    <p>
                      <strong>La mejor</strong>
                    </p>
                    <p>
                      <strong>tecnología</strong>
                    </p>
                    <p>
                      en soluciones 
                    </p>
                    <p>
                       visuales
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tercera sección (estructura mobile) - SOLO MOBILE */}
      <section className="anos-section d-block d-md-none">
        <div className="container-fluid">
          {/* Primera fila: títulos */}
          <div className="row mb-3">
            <div className="col-12 text-center">
              <h1 className="anos-title">60 AÑOS</h1>
              <h2 className="anos-subtitle">acompañando a Veracruz</h2>
            </div>
          </div>
          {/* Segunda fila: Carousel 1 y 2 */}
          <div className=" cont-strech">
            <div className="cont-strech-left">
              <div id="carouselExample1m" className="carousel slide anos-carousel" data-bs-ride="carousel">
                <div className="carousel-inner rounded-4">
                  <div className="carousel-item active" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/60anos1.png'} className="d-block w-100" alt="Variedad de lentes" />
                  </div>
                  <div className="carousel-item" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/1.png'} className="d-block w-100" alt="En tendencia" />
                  </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample1m" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExample1m" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
              <div className='red-square'>
                <p>Inmensa </p>
                <p><strong>variedad </strong></p>
                <p><strong>de marcas</strong></p>
              </div>
            </div>
            <div className="cont-strech-right">
              <div id="carouselExample2m" className="carousel slide anos-carousel" data-bs-ride="carousel">
                <div className="carousel-inner rounded-4">
                  <div className="carousel-item active" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/60anos2.png'} className="d-block w-100" alt="Variedad de Marcas" />
                  </div>
                  <div className="carousel-item" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/2.png'} className="d-block w-100" alt="Lentes de Dior" />
                  </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample2m" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExample2m" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
          
          {/* Tercera fila: Carousel 3 y Carousel 4 en dos columnas */}
          <div className="row mb-3 pt-3">
            {/* Columna izquierda: Logo y Carousel 3 */}
            <div className="col-6">
              <div className="text-center mb-2">
                <img src={process.env.PUBLIC_URL + '/logo60.png'} className="anos-logo my-3" alt="60 años viéndote, Ver" />
              </div>
              <div id="carouselExample3m" className="carousel slide anos-carousel" data-bs-ride="carousel">
                <div className="carousel-inner rounded-4">
                  <div className="carousel-item active" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/60anos3.png'} className="d-block w-100" alt="OPV equipado" />
                  </div>
                  <div className="carousel-item" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/3.png'} className="d-block w-100" alt="Examen de la vista" />
                  </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample3m" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExample3m" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            {/* Columna derecha: Carousel 4 */}
            <div className="col-6">
              <div id="carouselExample4m" className="carousel slide anos-carousel" data-bs-ride="carousel">
                <div className="carousel-inner rounded-4">
                  <div className="carousel-item active" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/60anos4.png'} className="d-block w-100" alt="Instalaciones" />
                  </div>
                  <div className="carousel-item" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/4.png'} className="d-block w-100" alt="Examen de la vista computarizada" />
                  </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample4m" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExample4m" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="col-12">
              <div className="red-square">
                <p><strong>Licenciados en Optometría</strong> </p>
                <p>en constante actualización</p>
              </div>
            </div>
          </div>
          {/* Quinta fila: Carousel 5 y recuadro */}
          <div className="row mb-3 align-items-end pt-3">
            <div className="col-12">
              <div id="carouselExample5m" className="carousel slide anos-carousel" data-bs-ride="carousel">
                <div className="carousel-inner mobile-5carousel rounded-4">
                  <div className="carousel-item active" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/60anos5.png'} className="d-block w-100" alt="Examen de corneo con tecnología" />
                  </div>
                  <div className="carousel-item" data-bs-interval="10000">
                    <img src={process.env.PUBLIC_URL + '/5.png'} className="d-block w-100" alt="Examen Topógrafo corneal" />
                  </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample5m" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExample5m" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
              <div className="red-square mt-2">
                <p><strong>La mejor tecnología </strong>en soluciones visuales</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cuarta sección*/}
      <section className="opciones-section">
        <div className="container-fluid">
          <div className="row opciones-bg align-items-stretch">
            <div className="col-lg-5 col-12 pt-md-5 pt-0 d-flex align-items-start justify-content-center">
              <p className="opciones-text">
                ¡Tantos modelos, marcas y precios que tus <br/>
                <span className="opciones-destacado">opciones serán ilimitadas!</span>
              </p>
            </div>
            <div className="col-lg-7 col-12 d-flex align-items-center justify-content-center">
              <div className="accordion opciones-accordion w-100" id="accordionOpciones">
                {/* Item 1 */}
                <div className="accordion-item bg-transparent border-0">
                  <h2 className="accordion-header" id="headingDia">
                    <button className="accordion-button collapsed opciones-accordion-header justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDia" aria-expanded="false" aria-controls="collapseDia">
                      <span className="d-flex align-items-center">
                        <img src={process.env.PUBLIC_URL + '/iconos/dia.png'} alt="Día a Día" className="opciones-icon" />
                        Para el Día a Día
                      </span>
                      <img src={process.env.PUBLIC_URL + '/iconos/Vector.svg'} alt="Flecha" className="opciones-arrow" />
                    </button>
                  </h2>
                  <div id="collapseDia" className="accordion-collapse collapse" aria-labelledby="headingDia" data-bs-parent="#accordionOpciones">
                    <div className="accordion-body opciones-accordion-body text-start">
                      <ul>
                        <li>Monofocales</li>
                        <li>Bifocales</li>
                        <li>Progresivos</li>
                        <li>Fotocromáticos</li>
                        <li>Para oficina</li>
                        <li>Para casa</li>
                        <li>Para escuela</li>
                        <li>Para industria</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Item 2 */}
                <div className="accordion-item border-white bg-transparent border-0">
                  <h2 className="accordion-header" id="headingOcupacionales">
                    <button className="accordion-button collapsed opciones-accordion-header  justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOcupacionales" aria-expanded="false" aria-controls="collapseOcupacionales">
                      <span className="d-flex align-items-center">
                        <img src={process.env.PUBLIC_URL + '/iconos/ocupacionales.png'} alt="Ocupacionales" className="opciones-icon" />
                        Ocupacionales
                      </span>
                      <img src={process.env.PUBLIC_URL + '/iconos/Vector.svg'} alt="Flecha" className="opciones-arrow" />
                    </button>
                  </h2>
                  <div id="collapseOcupacionales" className="accordion-collapse collapse" aria-labelledby="headingOcupacionales" data-bs-parent="#accordionOpciones">
                    <div className="accordion-body opciones-accordion-body text-start">
                      <ul>
                        <li>Antirreflejante</li>
                        <li>Fotocromáticos</li>
                        <li>Polarizados</li>
                        <li>Digitales</li>
                        <li>AI</li>
                        <li>Para oficina</li>
                        <li>Para casa</li>
                        <li>Para escuela</li>
                        <li>Para industria</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Item 3 */}
                <div className="accordion-item border-white bg-transparent border-0">
                  <h2 className="accordion-header" id="headingSol">
                    <button className="accordion-button collapsed opciones-accordion-header  justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSol" aria-expanded="false" aria-controls="collapseSol">
                      <span className="d-flex align-items-center">
                        <img src={process.env.PUBLIC_URL + '/iconos/sol.png'} alt="Sol" className="opciones-icon" />
                        De Sol
                      </span>
                      <img src={process.env.PUBLIC_URL + '/iconos/Vector.svg'} alt="Flecha" className="opciones-arrow" />
                    </button>
                  </h2>
                  <div id="collapseSol" className="accordion-collapse collapse" aria-labelledby="headingSol" data-bs-parent="#accordionOpciones">
                    <div className="accordion-body opciones-accordion-body text-start">
                      <ul>
                        <li>de sol graduados</li>
                        <li>de sol digitales</li>
                        <li>de sol polarizados graduados</li>
                        <li>polarizados</li>
                        <li>de sol graduados con AI</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Item 4 */}
                <div className="accordion-item border-white bg-transparent border-0">
                  <h2 className="accordion-header" id="headingTratamiento">
                    <button className="accordion-button collapsed opciones-accordion-header  justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTratamiento" aria-expanded="false" aria-controls="collapseTratamiento">
                      <span className="d-flex align-items-center">
                        <img src={process.env.PUBLIC_URL + '/iconos/tratamiento.png'} alt="Tratamiento" className="opciones-icon" />
                        De Tratamiento
                      </span>
                      <img src={process.env.PUBLIC_URL + '/iconos/Vector.svg'} alt="Flecha" className="opciones-arrow" />
                    </button>
                  </h2>
                  <div id="collapseTratamiento" className="accordion-collapse collapse" aria-labelledby="headingTratamiento" data-bs-parent="#accordionOpciones">
                    <div className="accordion-body opciones-accordion-body text-start">
                      <ul>
                        <li>Zeiss Duravision</li>
                        <li>Para ralentización de la miopía</li>
                        <li>Para cataratas</li>
                        <li>Para glaucoma</li>
                        <li>Para fotofobia</li>
                        <li>Fotocromáticos</li>
                        <li>Antirreflejantes para radiación UV y luz azul</li>
                        <li>Antirreflejantes especiales para manejo</li>
                        <li>Para ametropías como miopía, hipermetropía y astigmatismo</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Item 5 */}
                <div className="accordion-item border-white bg-transparent border-0">
                  <h2 className="accordion-header" id="headingContacto">
                    <button className="accordion-button collapsed opciones-accordion-header  justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseContacto" aria-expanded="false" aria-controls="collapseContacto">
                      <span className="d-flex align-items-center">
                        <img src={process.env.PUBLIC_URL + '/iconos/contacto.png'} alt="Contacto" className="opciones-icon" />
                        De Contacto
                      </span>
                      <img src={process.env.PUBLIC_URL + '/iconos/Vector.svg'} alt="Flecha" className="opciones-arrow" />
                    </button>
                  </h2>
                  <div id="collapseContacto" className="accordion-collapse collapse" aria-labelledby="headingContacto" data-bs-parent="#accordionOpciones">
                    <div className="accordion-body opciones-accordion-body text-start">
                      <ul>
                        <li>Blandos</li>
                        <li>Rígidos</li>
                        <li>Gaspermeables</li>
                        <li>Híbridos</li>
                        <li>Tóricos</li>
                        <li>Cosméticos</li>
                        <li>Terapéuticos</li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Item 6 */}
                <div className="accordion-item border-white-bottom bg-transparent border-0">
                  <h2 className="accordion-header" id="headingAccesorios">
                    <button className="accordion-button collapsed opciones-accordion-header justify-content-between" type="button" data-bs-toggle="collapse" data-bs-target="#collapseAccesorios" aria-expanded="false" aria-controls="collapseAccesorios">
                      <span className="d-flex align-items-center">
                        <img src={process.env.PUBLIC_URL + '/iconos/accesorio.png'} alt="Accesorios" className="opciones-icon" />
                        Accesorios
                      </span>
                      <img src={process.env.PUBLIC_URL + '/iconos/Vector.svg'} alt="Flecha" className="opciones-arrow" />
                    </button>
                  </h2>
                  <div id="collapseAccesorios" className="accordion-collapse collapse" aria-labelledby="headingAccesorios" data-bs-parent="#accordionOpciones">
                    <div className="accordion-body opciones-accordion-body text-start">
                      <ul>
                        <li>Soluciones de lentes de contacto</li>
                        <li>Cordones</li>
                        <li>Plaquetas</li>
                        <li>Tornillos</li>
                        <li>Soldaduras</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12 text-center">
              <p className="opciones-whatsapp mb-0">
                Muchas opciones y no sabes ¿cuál es la ideal para ti? <b><a href="https://wa.me/2293569081" className="opciones-link" target="_blank" rel="noopener noreferrer">da click aquí</a></b> y te asesoramos por <b>WhatsApp</b>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quinta sección - Cintas cruzadas tipo X (Outlet de lentes) */}
      <section className="section-bottom-border">
        {/* Primera fila - Cintas cruzadas */}
        {/*<div style={{height: 'fit-content', overflow: 'hidden', width:'100%'}}>
          <div className="outlet-x-section position-relative" style={{height: '225px', overflow: 'hidden'}}>
            <div className="outlet-x-ribbon outlet-x-ribbon-bottom" 
            style={{ transform: 'rotate(3deg)'}}>
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i + 50}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
            </div>
            <div className="outlet-x-ribbon outlet-x-ribbon-top" style={{ transform: ribbonTopTransform }}>
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
            </div>
          </div>
        </div>*/}
        
        {/* Primera fila - Cintas cruzadas */}
        <div style={{height: 'fit-content', overflow: 'hidden', width:'100%'}}>
          <div className="outlet-x-section position-relative" style={{height: '300px', overflow: 'hidden', background: '#fff'}}>
            <div
              className="outlet-x-ribbon outlet-x-ribbon-bottom"
              style={{
                animation: 'ribbon-move-right 20s linear infinite',
                whiteSpace: 'nowrap',
                position: 'absolute',
                left: 0,
                top: '35%',
                width: '200%',
                pointerEvents: 'none',
                zIndex: 2,
                transform: 'rotate(3deg)'
              }}
            >
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i + 50}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
            </div>
            <div
              className="outlet-x-ribbon outlet-x-ribbon-top"
              style={{
                animation: 'ribbon-move-left 20s linear infinite',
                whiteSpace: 'nowrap',
                position: 'absolute',
                top: '40px',
                left: 0,
                width: '200%',
                pointerEvents: 'none',
                zIndex: 2,
                transform: 'rotate(-4deg)'
              }}
            >
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
              <span>
                {Array(50).fill('Outlet de lentes').map((txt, i) => (
                  <span key={i + 50}>{txt} <span className="outlet-x-sep">|</span> </span>
                ))}
              </span>
            </div>
          </div>
        </div>
        {/* Segunda fila - Botón Mercado Libre */}
        <div className='container-fluid'>
          <div className="row justify-content-center align-items-center pb-5" style={{height: '40px'}}>
            <div className="col-auto">
              <a
                href="https://listado.mercadolibre.com.mx/_CustId_1228846715?item_id=MLM1679229684&category_id=MLM189030&seller_id=1228846715&client=recoview-selleritems&recos_listing=true#origin=vip&component=sellerData&typeSeller=classic"
                className="btn mercado-libre-btn d-flex align-items-center p-0"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <p className="btn-text">COMPRAR</p>
                <div className="btn-logo">
                  <img src={process.env.PUBLIC_URL + '/logo-ML.png'} alt="Mercado Libre" className="ml-logo" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home; 